import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import PaginationControlsV2 from "../../../global/PaginationControlsV2";
import useEntityAssociationsData from "../hooks/useEntityAssociationsData";
import { useEntityAssociationsStore } from "../store/entityAssociationsStore";

import EntityAssociationsTable from "./EntityAssociationsTable";

export default function EntityAssociations() {
  const { id: entityId } = useLoaderData();
  const { reset, data, loading, resultCount, currentPage, resLimit, setCurrentPage } =
    useEntityAssociationsStore();
  useEntityAssociationsData(entityId);

  useEffect(() => reset, [reset]);

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="relative flex flex-1 flex-col gap-2 overflow-y-auto">
        <EntityAssociationsTable data={data} isLoading={loading} />
      </div>
      {resultCount > resLimit && (
        <div className="relative flex w-full justify-center">
          <Stack alignItems="center">
            <PaginationControlsV2
              currentPage={currentPage}
              handleChange={(_event, page) => setCurrentPage(page)}
              resultCount={resultCount}
              resultLimit={resLimit}
            />
          </Stack>
        </div>
      )}
    </div>
  );
}
